import { createSlice } from '@reduxjs/toolkit';

import { mapExternalUsersFromDTO } from '@/store/mappers/mapExternalUsers';
import { deleteExternalUserThunk } from '@/store/thunks/externalUsers/deleteExternalUserThunk';
import { fetchExternalUsersThunk } from '@/store/thunks/externalUsers/fetchExternalUsersThunk';
import { extractThunkError } from '@/store/utils';
import { initialExternalUsersState } from '@/types/external-users.types';

const externalUsersSlice = createSlice({
  name: 'externalUsers',
  initialState: initialExternalUsersState,
  reducers: {
    resetExternalUsersState: () => initialExternalUsersState,
    toggleInvitedByMeFilter: (state) => {
      state.invitedByMeOnly = !state.invitedByMeOnly;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExternalUsersThunk.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchExternalUsersThunk.fulfilled, (state, action) => {
        state.users = mapExternalUsersFromDTO(action.payload);
        state.isLoaded = true;
        state.error = null;
      })
      .addCase(fetchExternalUsersThunk.rejected, (state, action) => {
        const { message } = extractThunkError(action.payload);
        state.error = message ?? action.error.message ?? 'Unknown error';
      })
      .addCase(deleteExternalUserThunk.pending, (state) => {
        state.isDeleting = true;
      })
      .addCase(deleteExternalUserThunk.fulfilled, (state) => {
        state.isDeleting = false;
      })
      .addCase(deleteExternalUserThunk.rejected, (state) => {
        state.isDeleting = false;
      });
  },
});

export const { resetExternalUsersState, toggleInvitedByMeFilter } = externalUsersSlice.actions;
export default externalUsersSlice.reducer;
